import React from 'react';
import "./Cproject.css";
import img1 from "../../assets/Project/Chengalpet Chennai Apartment project.jpeg";
import img2 from "../../assets/Project/Madhavaram Chennai Individual House .jpg";
import img3 from "../../assets/Project/Medavakkam Chennai Apartment project.jpeg";
import { useNavigate } from 'react-router-dom';
 

function Cproject() {
	const navigate = useNavigate();
  return (
    <>
    <section class="padding ptb-xs-40">
    <div class="row text-center mb-30">
					<div class="col-sm-12">
						<div class="sec_hedding">
							<h2><span>Our</span> Project</h2>
						<div className='underline-service'></div>
						</div>
					</div>
				</div>
			<div class="container">
				

				<div class="row">
					<div class="col-lg-4 mb-sm-30 mb-xs-30" style={{ marginBottom:"20px"}}>
						<div class="position_relative img-scale max_size">
							<figure class="picher_doc" >
								<img src={img1} alt="" style={{ width:"100%", height:"auto"}}/>
								<div class="opacity-medium bg-extra-black"></div>
								<div class="date_top">
									<span>Chengalpet, Chennai</span>
								</div>
								<div class="inner_text">
									{/* <h3 class="show_tital">Big bugets for startup</h3> */}

									{/* <p class="display_block">
										A Rich Heritage &amp; Brand History
									</p> */}
									<button class="button-project" onClick={() =>
									{
										window.scrollTo(0,0);
										navigate("/all-project")}
									}
									>
										view More
									</button>
								</div>
							</figure>
						</div>
					</div>

					<div class="col-lg-4 mb-sm-30 mb-xs-30" style={{ marginBottom:"20px"}}>
						<div class="position_relative img-scale max_size">
							<figure class="picher_doc">
								<img src={img2} alt=""/>
								<div class="opacity-medium bg-extra-black"></div>
								<div class="date_top">
									<span>Madhavaram, Chennai</span>
								</div>
								<div class="inner_text">
									{/* <h3 class="show_tital">Big bugets for startup</h3>

									<p class="display_block">
										A Rich Heritage &amp; Brand History
									</p> */}
									<button class="button-project" onClick={() => 
									{
										window.scrollTo(0,0);
										navigate("/all-project")}
									}
								
									>
										view More
									</button>
								</div>
							</figure>
						</div>
					</div>

				
					<div class="col-lg-4 mb-sm-30 mb-xs-30" style={{ marginBottom:"20px"}}>
						<div class="position_relative img-scale max_size">
							<figure class="picher_doc">
								<img src={img3} alt=""/>
								<div class="opacity-medium bg-extra-black"></div>
								<div class="date_top">
									<span>Medavakkam, Chennai</span>
								</div>
								<div class="inner_text">
									{/* <h3 class="show_tital">Big bugets for startup</h3>

									<p class="display_block">
										A Rich Heritage &amp; Brand History
									</p> */}
									<button class="button-project"  
									onClick={() =>
										{
											window.scrollTo(0,0);
											navigate("/all-project")}
										}
									 >
										view More
									</button>
								</div>
							</figure>
						</div>
					</div>
				</div>

			</div>
		</section></>
  )
}

export default Cproject